import PipelinePageContainer from './containers/PipelinePageContainer'

export default PipelinePageContainer
